import { render, staticRenderFns } from "./IconTooltip.vue?vue&type=template&id=ab5e35a8&scoped=true"
import script from "./IconTooltip.vue?vue&type=script&lang=js"
export * from "./IconTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5e35a8",
  null
  
)

export default component.exports